<template>
  <div class="get_started_list_section achievements_section achievements_main achievements_prof" v-if="userDetails.gamesPlayed > 0">

    <div class="ach_prof_title">{{ getTranslations.home_profile_profile_achievements_title }}</div>
    <img v-if="hasFilters" src="static/images/achievements/icon-Achievements.png" class="home_achievements_img">

<!--    <div v-if="hasFilters" class="filter achievements_filter"> &lt;!&ndash; TODO Filter Functionality &ndash;&gt;-->
<!--      <a class="all current" href="#"> {{ getTranslations.home_achievements_all }} </a>-->
<!--      <a class="weekly" href="#"> {{ getTranslations.home_achievements_weekly }} </a>-->
<!--      <a class="monthly" href="#"> {{ getTranslations.home_achievements_monthly }} </a>-->
<!--    </div>-->
    <div class="filter" v-if="achievements.length === 1">
      <a v-for="(achievement, index) in achievements"
         :key="index"
         :class="[ changeClass(index), {current: activeTab === index }]"
         style="cursor: text;">
        {{ getTranslatedValue(index + 1) }}
      </a>
    </div>
    <div class="filter" v-else>
      <a v-for="(achievement, index) in achievements"
         :key="index"
         :class="[ changeClass(index), {current: activeTab === index }]"
         href="#"
         @click.prevent="changeTab(index)">
        {{ getTranslatedValue(index + 1) }}
      </a>
    </div>
    <div class="filter_list">
      <div :class="['list_item', changeClass(activeTab)]">
        <achievements-tab v-for="(achievement, index) in achievements"
                          :key="index"
                          :is-active="activeTab === index"
                          :categories="achievement.achievementDTOs"/>
      </div>
    </div>
  </div>
  <div class="performance_box empty" v-else>
    <h1>{{ getTranslations.home_profile_profile_achievements_empty }}</h1>
    <img src="/static/images/profile/profile-emptystate.png">
    <p>{{ getTranslations.home_profile_profile_your_achievements_empty }}</p>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import AchievementsTab from '@/components/home/modals/achievements/AchievementsTab';
import AchievementsCircle from './AchievementsCircle';

export default {
  name: 'achievements-profile',
  props: {
    hasFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: { AchievementsCircle, AchievementsTab },
  data() {
    return {
      activeTab: 0,
      styleCss: ['achievement_row logic', 'achievement_row attention', 'achievement_row memory', 'achievement_row mixed'],
      imageCss: ['/static/images/games/icon-logic.png', '/static/images/games/icon-attention.png', '/static/images/games/icon-memory.png', '/static/images/games/icon-mixed.png'],
      nameCategory: ['', '', '', ''],
      data0: 0,
      data1: 0,
      data2: 0,
      data3: 0,
      index: 0,
      j: 3,
      gamesUnlocked: 0,
    };
  },
  created() {
    this.data0 = this.performanceInfo.logicMiniGamesAccuracy ? parseFloat(this.performanceInfo.logicMiniGamesAccuracy).toFixed(1) : 0;
    this.data1 = this.performanceInfo.memoryMiniGamesAccuracy ? parseFloat(this.performanceInfo.memoryMiniGamesAccuracy).toFixed(1) : 0;
    this.data2 = this.performanceInfo.attentionMiniGamesAccuracy ? parseFloat(this.performanceInfo.attentionMiniGamesAccuracy).toFixed(1) : 0;
    this.data3 = this.performanceInfo.mixedMiniGamesAccuracy ? parseFloat(this.performanceInfo.mixedMiniGamesAccuracy).toFixed(1) : 0;
    this.nameCategory[0] = this.getTranslations.home_profile_profile_genious;
    this.nameCategory[1] = this.getTranslations.home_profile_profile_attention_genious;
    this.nameCategory[2] = this.getTranslations.home_profile_profile_wizard;
    this.nameCategory[3] = this.getTranslations.home_profile_profile_all_rounder;
  },
  methods: {
    dataGames(index) {
      let data = 0;
      switch (index) {
      case 0: data = this.performanceInfo.logicMiniGamesPlayed;
        break;
      case 1: data = this.performanceInfo.attentionMiniGamesPlayed;
        break;
      case 2: data = this.performanceInfo.memoryMiniGamesPlayed;
        break;
      default:
        data = this.performanceInfo.mixedMiniGamesPlayed;
        break;
      }
      return data;
    },
    dataAchievements(index) {
      let data = 0;
      switch (index) {
      case 0: data = this.data0;
        break;
      case 1: data = this.data1;
        break;
      case 2: data = this.data2;
        break;
      default:
        data = this.data3;
        break;
      }
      return data;
    },
    changeStatus() {
      return this.$router.push('/home/achievements');
    },
    changeClass(index) {
      if (index === 0) {
        return 'grand';
      } else if (index === 1) {
        return 'weekly';
      }
      return 'monthly';
    },
    changeTab(index) {
      this.activeTab = index;
    },
    getTranslatedValue(index) {
      return this.getTranslations[`home_achievements_category${index}`];
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('profile', [
      'performanceInfo',
      'achievements',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/profile/AchievementsProfile.vue